exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clearcart-btn[data-v-6db4e95e]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}\n", ""]);

// exports
